<template>
  <div>
    <order-details
      ref="orderDetailsModal"
      :selected-order="selectedOrder"
      :order-date="orderDate"
      @onProcessOrder="processOrder(selectedOrder)"
      @onHandOver="handOver(selectedOrder)"
      @onCompleteDelivery="completeDelivery(selectedOrder)"
      @onOpenSupportContentModal="openSupportContentModal(selectedOrder)"
    />
    <Layout>
      <pt-modal ref="processConfirmModal" size="medium">
        <div slot="modal-header">Confirmation</div>
        <div slot="modal-body">
          <p v-if="action" class="pb-4">
            Tracking ID: <span class="font-bold">{{ action.tracking_id }}</span>
          </p>
          <p class="font-bold text-lg">{{ text }}</p>
        </div>
        <div slot="modal-footer">
          <pt-button class="w-full md:w-1/3" variant="primary" @action="submitSupportModal">
            Submit
          </pt-button>
          <pt-button
            variant="secondary-outline"
            class="ml-0 sm:mt-2 md:mt-0 md:ml-2 w-full md:w-1/3"
            @action="cancelSupportModal"
          >
            Cancel
          </pt-button>
        </div>
      </pt-modal>
      <pt-modal ref="orderCancelModal" size="medium" close-button-position-in-header="right">
        <div slot="modal-header">Confirmation</div>
        <div slot="modal-body">
          <p class="font-bold pb-2">Tracking ID: {{ action.tracking_id }}</p>
          <p class="pb-3">Cancellation Reasons</p>
          <div v-for="(reason, index) in orderCancellationReasons" :key="index" class="pb-2">
            <label class="form-check-label">
              <input v-model="cancelReason" :value="reason.value" type="radio" class="form-check-input" />
              {{ reason.label }}
            </label>
          </div>
          <div v-if="cancelReason === 'Others'" class="pt-form-group-container">
            <pt-form-input v-model="otherReason" type="text" placeholder="Enter Other Reason" />
          </div>
        </div>
        <div slot="modal-footer">
          <pt-button variant="primary" class="mr-0 md:mr-2 mb-2 md:mb-0 w-full md:w-1/3" @action="submitSupportModal">
            Submit
          </pt-button>
          <pt-button class="w-full md:w-1/3" variant="secondary" @action="closeOrderCancelModal">
            Cancel
          </pt-button>
        </div>
      </pt-modal>
      <pt-modal ref="supportContentModal" size="medium" class="confirmation-modal">
        <!-- <div slot="modal-header">Confirmation</div> -->
        <div slot="modal-body">
          <pt-button :is-full-width="true" variant="primary" class="mb-4" @action="requestForCall">
            Request For Call
          </pt-button>
          <pt-button :is-full-width="true" variant="secondary-outline" @action="requestSupportToCancelOrder">
            Cancel Order
          </pt-button>
        </div>
      </pt-modal>
      <div class="px-2">
        <div class="flex flex-wrap -mx-2">
          <div class="w-1/2 lg:w-1/6 pr-2 mb-4">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Total Earnings</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <div v-else class="card-info">
                <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                <span v-else>रू</span>
                {{ stats.earnings }}
              </div>
            </div>
          </div>
          <div class="w-1/2 lg:w-1/6 lg:pr-2">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Active Order</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="card-info">{{ stats.active_order }}</p>
            </div>
          </div>
          <div class="w-1/2 lg:w-1/6 pr-2 mb-4">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Total Daily Order</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="card-info">{{ stats.total_order }}</p>
            </div>
          </div>
          <div class="w-1/2 lg:w-1/6 lg:pr-2">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Order Delivered</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="card-info">{{ stats.delivered_order }}</p>
            </div>
          </div>
          <div class="w-1/2 lg:w-1/6 pr-2">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Cancelled Orders</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <p v-else class="card-info">{{ stats.cancelled_order }}</p>
            </div>
          </div>
          <div class="w-1/2 lg:w-1/6">
            <div class="bg-white pl-4 py-4 card">
              <p class="card-title pb-2">Avg Processing Time</p>
              <p v-if="fetchingStats"><i class="fa fa-refresh fa-spin" /> Loading...</p>
              <div v-else>
                <p v-if="stats.avg_processing_time" class="card-info">
                  {{ (stats.avg_processing_time / 60).toFixed(2) }} min
                </p>
                <p v-else class="card-info">0 min</p>
              </div>
            </div>
          </div>
        </div>
        <!-- No order found -->
        <div v-if="isOrderNotFound" class="w-full max-h-screen md:py-12 sm:py-8 bg-white">
          <div class="text-center m-auto">
            <i class="icon-ic icon-ic-orders-issues text-lg" />
            <p class="test-center text-lg font-bold mt-4">No Match Found</p>
            <p class="my-4 text-grey-dark">We cannot find any orders matches your search. <br />Please try a different search.</p>
          </div>
        </div>
      </div>
      <div class="order-details-section lg:flex border-t border-solid lg:mt-8 sm:mt-12">
        <div class="w-full bg-white">
          <div class="pt-form-group-container token p-2 w-full bg-grey-light">
            <pt-form-input
              v-model="searchToken"
              type="text"
              placeholder="Search with Token"
              icon-class="fa-search"
              icon-position="left"
            />
          </div>
          <div v-if="isOrderAvailable(placedOrders)" class="card">
            <div class="card-header bg-grey-light">
              <p class="p-4 leading-normal font-bold text-lg">Accepted Order</p>
            </div>
            <div
              v-for="(order, index) in getFilteredOrders(placedOrders)"
              :key="index"
              :class="[order.tracking_id === selectedTrackingID ? 'selected' : '']"
              class="card-border-bottom bg-white px-4 py-6 lg:flex lg:justify-between border-solid border-l-4 border-red relative"
            >
              <div class="cursor-pointer sm:mb-4" @click="fetchDetails(order)">
                <p class="leading-tight text-base font-bold pb-2">
                  Token ID {{ order.serial_no }}
                  <span class="order-status text-sm px-2 ml-4 self-center mt-2">{{ order.status }}</span>
                </p>
                <p class="text-sm text-grey-dark">OrderID #{{ order.tracking_id }}</p>
                <div v-if="order.processing_time" class="pt-4 pb-4">
                  Time Elapsed {{ (order.processing_time / 60).toFixed(2) }} min
                </div>
                <div v-else class="pt-4 pb-4">Time Elapsed 0 mins</div>
              </div>
              <div class="self-center">
                <pt-button
                  variant="primary"
                  class="mr-0 md:mr-2 mb-2 w-full md:w-1/2 lg:w-full"
                  @action="processOrder(order)"
                >
                  processing
                </pt-button>
                <pt-button class="w-full md:w-1/2 lg:w-full" variant="secondary" @action="cancelOrder(order, index)">
                  cancel
                </pt-button>
                <div v-if="order.driver_details" class="carrier flex items-center p-2 border mt-2">
                  <img
                    :src="'https://cdn.pathao.com/' + order.driver_details.profile_pic"
                    class="w-10 h-10 rounded-full mr-4"
                    alt="driver image"
                  />
                  <div class="text-sm">
                    <p class="font-bold">Carrier</p>
                    <p class="text-black leading-none">{{ order.driver_details.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isOrderAvailable(processingOrders)" class="card">
            <div class="card-header bg-grey-light">
              <p class="p-4 leading-normal font-bold text-lg">Processing</p>
            </div>
            <div
              v-for="(order, index) in getFilteredOrders(processingOrders)"
              :key="index"
              :class="[order.tracking_id === selectedTrackingID ? 'selected' : '']"
              class="card-border-bottom bg-white px-4 py-6 lg:flex lg:justify-between border-solid border-l-4 border-yellow"
            >
              <div class="cursor-pointer sm:mb-4" @click="fetchDetails(order)">
                <p class="leading-tight text-base font-bold pb-2">
                  <span> Token ID {{ order.serial_no }} </span>
                  <span class="process-status py-1 text-sm px-2 ml-4 self-center">Processing</span>
                </p>
                <p class="text-sm text-grey-dark">OrderID #{{ order.tracking_id }}</p>
                <div v-if="order.processing_time" class="pt-4 pb-4">
                  Time Elapsed {{ (order.processing_time / 60).toFixed(2) }} min
                </div>
                <div v-else class="pt-4 pb-4">Time Elapsed 0 mins</div>
              </div>
              <div class="self-center">
                <pt-button variant="primary" class="mr-2 mb-2" @action="handOver(order)">
                  Handover
                </pt-button>
                <pt-button variant="secondary-outline" @action="openSupportContentModal(order)">
                  support
                </pt-button>
                <div v-if="order.driver_details" class="carrier flex items-center p-2 border mt-2">
                  <img
                    :src="'https://cdn.pathao.com/' + order.driver_details.profile_pic"
                    class="w-10 h-10 rounded-full mr-4"
                    alt="driver image"
                  />
                  <div class="text-sm">
                    <p class="font-bold">Carrier</p>
                    <p class="text-black leading-none">{{ order.driver_details.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isOrderAvailable(handoverOrders)" class="card">
            <div class="card-header bg-grey-light">
              <p class="p-4 leading-normal font-bold text-lg">Handed Over</p>
            </div>
            <div
              v-for="(order, index) in getFilteredOrders(handoverOrders)"
              :key="index"
              :class="[order.tracking_id === selectedTrackingID ? 'selected' : '']"
              class="card-border-bottom bg-white px-4 py-6 lg:flex lg:justify-between border-solid border-l-4 border-blue"
            >
              <div class="cursor-pointer sm:mb-4" @click="fetchDetails(order)">
                <p class="leading-tight text-base font-bold pb-2">
                  <span> Token ID {{ order.serial_no }} </span>
                  <span class="process-status py-1 text-sm px-2 ml-4 self-center">Handed Over</span>
                </p>
                <p class="text-sm text-grey-dark">OrderID #{{ order.tracking_id }}</p>
                <div v-if="order.processing_time" class="pt-4 pb-4">
                  Time Elapsed {{ (order.processing_time / 60).toFixed(2) }} min
                </div>
                <div v-else class="pt-4 pb-4">Time Elapsed 0 mins</div>
              </div>
              <div class="self-center">
                <pt-button
                  v-if="isChain"
                  variant="primary"
                  class="mr-2 mb-2 complete-btn w-full"
                  @action="completeDelivery(order)"
                >
                  Complete Delivery
                </pt-button>
                <div v-if="order.driver_details" class="carrier flex items-center p-2 border mt-2">
                  <img
                    :src="'https://cdn.pathao.com/' + order.driver_details.profile_pic"
                    class="w-10 h-10 rounded-full mr-4"
                    alt="driver image"
                  />
                  <div class="text-sm">
                    <p class="font-bold">Carrier</p>
                    <p class="text-black leading-none">{{ order.driver_details.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- No order found -->
          <div v-if="isOrderNotFound" class="w-full max-h-screen md:py-12 sm:py-8 bg-white">
            <div class="text-center m-auto">
              <i class="icon-ic icon-ic-orders-issues text-lg" />
              <p class="test-center text-lg font-bold mt-4">No Match Found</p>
              <p class="my-4 text-grey-dark">
                We cannot find any orders matches your search. <br />Please try a different search.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>

    <pt-loader v-if="isDetailsLoading" icon-class="fa-refresh fa-5x text-white" container="body" />
  </div>
</template>

<script>
import Layout from '@layouts/main';
import { mapGetters, mapActions } from 'vuex';
import { RESTO_ORDERS, ORDER_STATS, UPDATE_ORDER, REQUEST_SUPPORT, GET_ORDER_DETAILS } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { PtLoader } from '@pathao/ui-components/esm/Loader';
import isEmpty from 'lodash/isEmpty';
import { format, parse } from 'date-fns';
import isChain from '@src/mixins/isChain';
import PtPhotoGallery from '@src/components/custom/PhotoGallery';
import getTimeZone from '@src/utils/getTimeZone';
import { ORDER_CANCELLATION_REASON } from '@src/constants';
import OrderDetails from '@components/modals/orderDetails';
import isPWA from '@src/utils/is-pwa';
import isBDPhoneNumber from '@src/utils/isBdNumber';

export default {
  name: 'Orders',
  page: {
    title: 'Orders',
  },
  components: {
    Layout,
    PtModal,
    PtPhotoGallery,
    PtLoader,
    OrderDetails,
  },
  mixins: [isChain],
  data() {
    return {
      text: '',
      fetchingStats: false,
      selectedTrackingID: '',
      assignedOrders: [],
      acceptedOrders: [],
      pickedUpOrders: [],
      pendingOrders: [],
      placedOrders: [],
      submitting: false,
      processingOrders: [],
      handoverOrders: [],
      notifications: [],
      orderDate: '',
      selectedOrder: {},
      stats: '',
      action: '',
      cancelReason: 'Busy cooks',
      orderCancellationReasons: ORDER_CANCELLATION_REASON,
      otherReason: '',
      searchToken: '',
      showOrderDetailsModal: false,
      isDetailsLoading: false,
    };
  },
  computed: {
    isOrderNotFound() {
      if (!this.searchToken) {
        return false;
      }
      return (
        this.getFilteredOrders(this.placedOrders).length <= 0 &&
        this.getFilteredOrders(this.processingOrders).length <= 0 &&
        this.getFilteredOrders(this.handoverOrders).length <= 0
      );
    },
    ...mapGetters({
      orders: 'app/getOrderObj',
    }),
    hasSelectedOrder() {
      return !isEmpty(this.selectedOrder);
    },
  },
  watch: {
    orders(newValue) {
      this.checkFood(newValue[0]);
    },
    searchToken(newValue) {
      if (newValue.length > 3) {
        this.$sendEvent('RS_SearchToken');
      }
    },
  },
  created() {
    this.getStats();
    this.getOrders();

    this.$sendEvent('RS_order');
    if (isPWA()) {
      this.$sendEvent('RS_PwaApp');
    } else {
      this.$sendEvent('RS_WebApp');
    }
  },
  methods: {
    isBDPhoneNumber,
    ...mapActions({
      storeOrderObj: 'app/fetchOrderObj',
    }),
    fetchDetails(order) {
      this.selectedTrackingID = order.tracking_id;

      if (this.hasSelectedOrder) {
        if (this.selectedOrder.tracking_id === this.selectedTrackingID) {
          this.$refs.orderDetailsModal.show();
          return;
        }
      }

      this.isDetailsLoading = true;
      let payload = {
        url: GET_ORDER_DETAILS + order.id,
        method: 'GET',
      };
      apiRequest(payload)
        .then(response => {
          if (response.data.success) {
            this.selectedOrder = response.data.order;
            this.orderDate = format(parse(this.selectedOrder.order_at), 'ddd, MMM DD, YYYY hh:mm a');

            let push = {
              order_id: this.selectedOrder.tracking_id,
              basket_size: this.selectedOrder.items[0].quantity,
              basket_value: this.selectedOrder.total_collectable,
              promo_code: this.selectedOrder.promo_code,
              status: this.selectedOrder.status,
            };
            this.$sendEvent('RS_OrderDetails', push);
            this.$refs.orderDetailsModal.show();
            this.isDetailsLoading = false;
          }
        })
        .catch(() => {
          this.$notification.error('Failed to fetch Order Details');
          this.isDetailsLoading = false;
        });
    },
    closeOrderCancelModal() {
      this.$refs.orderCancelModal.closeModal();
    },
    requestSupportToCancelOrder() {
      this.$refs.supportContentModal.closeModal();
      this.text = 'Are you sure you want to call cancel this order?';
      this.action.type = 'support_cancel_order';
      this.$refs.orderCancelModal.showModal();
    },
    requestForCall() {
      this.$refs.supportContentModal.closeModal();
      this.$nextTick(() => {
        this.action.type = 'support_call';
        this.text = 'Are you sure you want to call request to call support?';
        this.$refs.processConfirmModal.showModal();
      });
    },
    openSupportContentModal(order) {
      this.action = order;
      this.action.type = 'support';
      this.$refs.supportContentModal.showModal();
    },
    handOver(order) {
      this.action = order;
      this.text = 'Are you sure you want to handover this order?';
      this.action.type = 'handover';
      this.$refs.processConfirmModal.showModal();
    },
    completeDelivery(order) {
      this.action = order;
      this.text = 'Are you sure you want to complete this order?';
      this.action.type = 'complete_delivery';
      this.$refs.processConfirmModal.showModal();
    },
    cancelOrder(order, idx) {
      this.action = order;
      this.action.type = 'cancel_order';
      this.action.index = idx;
      this.$refs.orderCancelModal.showModal();
    },
    processOrder(order) {
      this.action = order;
      this.text = 'Are you sure you want to process this order?';
      this.action.type = 'process_order';
      this.$refs.processConfirmModal.showModal();
    },
    requestForSupport() {
      let event = 'RS_CallRequestSubmit';
      let payload = {
        url: REQUEST_SUPPORT,
        method: 'POST',
        data: {
          order_id: this.action.id,
          type: 'REQUEST_CALL',
          message: 'Request for support call',
        },
      };

      if (this.action.type === 'support_cancel_order') {
        // For chain resto direct cancel for processing state
        if (this.isChain && this.action.status === 'PLACED') {
          this.action.type = 'cancel_order';
          this.updateOrder();
          return true;
        } else {
          payload.data.type = 'CANCEL_ORDER';
          payload.data.message = 'Request support to cancel order';
        }
        event = 'RS_Support';
      }

      let push = {
        order_tracking_id: this.action.tracking_id,
        basket_value: this.action.subtotal,
        promo_code: this.action.promo_code,
      };
      this.$sendEvent(event, push);

      apiRequest(payload).then(response => {
        this.$refs.processConfirmModal.closeModal();
        this.$refs.orderCancelModal.closeModal();
        if (response.data.success) {
          this.$notification.success(response.data.message);
        }
      });
    },
    updateOrder() {
      let payload = {
        url: UPDATE_ORDER,
        method: 'POST',
        data: {
          order_id: this.action.id,
          status: this.action.status,
        },
      };
      this.$refs.processConfirmModal.closeModal();
      if (this.action.type === 'cancel_order') {
        let cancelationReason = this.cancelReason;
        if (this.cancelReason === 'Others') {
          if (!this.otherReason) {
            this.$notification.error('Please Enter Other Reason Or Choose From Given One.');
            return false;
          }
          cancelationReason = this.otherReason;
        }
        // For isChain, order will be Caneled directly
        if (this.isChain) {
          payload.data.status = 'CANCELED';
          payload.data.cancellation_reason = cancelationReason;
        } else {
          payload.url = REQUEST_SUPPORT;
          payload.data.type = 'CANCEL_ORDER';
          payload.data.message = cancelationReason;
        }
        this.$refs.orderCancelModal.closeModal();
      }
      if (this.action.type === 'handover') {
        payload.data.order_id = this.action.id;
        payload.data.status = 'HANDOVER';
      }
      if (this.action.type === 'complete_delivery') {
        payload.data.order_id = this.action.id;
        payload.data.status = 'DELIVERED';
      }

      if (this.action.type === 'process_order') {
        payload.data.order_id = this.action.id;
        payload.data.status = 'PROCESSING';
      }
      apiRequest(payload)
        .then(response => {
          if (response.data.success) {
            this.$notification.success(response.data.message);
            if (this.action.type === 'cancel_order' && !this.isChain) {
              return;
            }
            let trackingId = this.action.tracking_id;
            let status = payload.data.status;
            for (let order of this.placedOrders) {
              if (order.tracking_id === trackingId && status === 'CANCELED') {
                let index = this.placedOrders.indexOf(order);
                this.placedOrders.splice(index, 1);
                this.$notification.success('Order ID ' + order.tracking_id + ' Has Been Canceled.');
                if (this.selectedOrder.tracking_id === trackingId) {
                  this.selectedOrder = {};
                }
                continue;
              }
              if (order.tracking_id === trackingId && status === 'PROCESSING') {
                let index = this.placedOrders.indexOf(order);
                this.placedOrders.splice(index, 1);
                this.processingOrders.push(this.action);

                if (this.selectedOrder.tracking_id === trackingId) {
                  this.selectedOrder.status = status;
                }
                return;
              }
            }
            for (let order of this.processingOrders) {
              if (order.tracking_id === trackingId && status === 'HANDOVER') {
                let index = this.processingOrders.indexOf(order);
                this.processingOrders.splice(index, 1);
                this.handoverOrders.push(this.action);

                if (this.selectedOrder.tracking_id === trackingId) {
                  this.selectedOrder.status = status;
                }
                return;
              }
            }
            for (let order of this.handoverOrders) {
              if (order.tracking_id === trackingId && status === 'DELIVERED') {
                let index = this.handoverOrders.indexOf(order);
                this.handoverOrders.splice(index, 1);
                this.selectedOrder = {};
                return;
              }
            }
          } else {
            this.$notification.error(response.data.message);
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 500) {
            this.getOrders();
          }
          let errorMessage =
            err.response && err.response.data
              ? err.response.data.message
              : 'May be something is wrong. Server is down or not responding.';
          this.$notification.error(errorMessage);
        });
    },
    cancelSupportModal() {
      this.$refs.processConfirmModal.closeModal();
    },
    submitSupportModal() {
      switch (this.action.type) {
        case 'cancel_order':
        case 'process_order':
        case 'handover':
        case 'complete_delivery':
          this.updateOrder();
          this.sendOrderUpdateEvent();
          break;
        case 'support_call':
        case 'support_cancel_order':
          this.requestForSupport();
          break;
        default:
          break;
      }
    },
    sendOrderUpdateEvent() {
      let push = {
        order_status: this.action.status,
        order_tracking_id: this.action.tracking_id,
        basket_value: this.action.subtotal,
        promo_code: this.action.promo_code,
        payment_mode: this.action.payment_mode,
      };
      if (this.action.type === 'cancel_order') {
        push.cancellation_reason = this.cancelReason === 'Others' ? this.otherReason : this.cancelReason;
      }
      const eventName = `RS_${this.action.type}`;
      this.$sendEvent(eventName, push);
    },
    getStats() {
      let payload = {
        url: ORDER_STATS,
        method: 'GET',
      };
      this.fetchingStats = true;
      apiRequest(payload).then(response => {
        this.fetchingStats = false;
        this.stats = response.data.stats;
      });
    },
    getOrders() {
      let payload = {
        url: RESTO_ORDERS + '?timezone=' + getTimeZone(),
        method: 'GET',
      };

      apiRequest(payload).then(response => {
        let orders = response.data.orders;
        if (response.data.success) {
          this.placedOrders = orders.PLACED;
          this.processingOrders = orders.PROCESSING;
          this.acceptedOrders = orders.ACCEPTED;
          this.pickedUpOrders = orders.PICKED_UP;
          this.handoverOrders = orders.HANDOVER;
          if (!this.processingOrders) {
            this.processingOrders = [];
          }

          if (!this.acceptedOrders) {
            this.acceptedOrders = [];
          }
          if (!this.assignedOrders) {
            this.assignedOrders = [];
          }
          if (!this.placedOrders) {
            this.placedOrders = [];
          }
          if (!this.handoverOrders) {
            this.handoverOrders = [];
          }
        } else {
          this.processingOrders = [];
          this.acceptedOrders = [];
          this.assignedOrders = [];
          this.placedOrders = [];
          this.handoverOrders = [];
        }
      });
    },
    checkFood(order) {
      switch (order.status) {
        case 'PENDING':
          break;
        case 'PLACED':
          this.placedOrders.unshift(order);
          break;
        case 'HANDOVER':
          let index = this.processingOrders.findIndex(o => o.tracking_id === order.tracking_id);
          if (index > -1) {
            this.processingOrders.splice(index, 1);
            this.handoverOrders.unshift(order);
            if (this.hasSelectedOrder && this.selectedOrder.id === order.id) {
              this.selectedOrder = {};
            }
          }
          break;
        case 'ACCEPTED':
          this.getOrders();
          if (this.hasSelectedOrder && this.selectedOrder.id === order.id) {
            this.selectedOrder = {};
          }
          break;
        case 'CANCELED':
          this.getOrders();
          if (this.hasSelectedOrder && this.selectedOrder.id === order.id) {
            this.selectedOrder = {};
          }
          break;
        case 'DELIVERED':
          break;
        default:
          break;
      }
    },
    setIndex(index) {
      this.$refs.gallery.setIndex(index);
      this.$refs.gallery.show();
    },
    getFilteredOrders(orders = []) {
      let filteredOrders = orders;
      if (this.searchToken) {
        filteredOrders = orders.filter(order =>
          order.serial_no ? order.serial_no.toString().includes(this.searchToken) : false
        );
      }
      return filteredOrders;
    },
    isOrderAvailable(orders) {
      return (
        (!this.searchToken && orders.length > 0) || (this.searchToken && this.getFilteredOrders(orders).length > 0)
      );
    },
  },
};
</script>

<style type="text/css">
.selected {
  background: #f5f5f5;
}
.card-border-bottom {
  border-bottom: 2px solid #ddd;
}
.handover-status {
  color: #3b99fc;
  background-color: rgba(59, 153, 252, 0.15);
}
.process-status {
  color: #ffac2a;
  background-color: rgba(255, 172, 42, 0.15);
}
.order-status {
  background-color: rgba(232, 51, 48, 0.15);
  color: #e83330;
}
.card {
  border: 1px solid #dddddd;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
.card-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: -0.03px;
  text-align: left;
  line-height: 22px;
}
.card-info {
  font-size: 32px;
  color: rgba(0, 0, 0, 0.87);
  text-align: left;
  line-height: 40px;
}
.card-border-bottom:hover {
  box-shadow: 0 0 6px #3b99fc;
}
@media (max-width: 992px) {
  .pt-modal-wrapper .pt-modal-container.medium {
    width: 90%;
  }
  .pt-modal-wrapper .pt-modal-container.small {
    width: 90%;
  }
  .card-info {
    font-size: 22px;
  }
  .card-title {
    font-size: 12px !important;
    line-height: 0px !important;
  }
}
.prescription img {
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
.prescription:hover img {
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}
.total {
  margin-top: 4px;
}
.token input {
  line-height: 2.5;
}
.complete-btn {
  min-width: 9rem !important;
}
</style>
